import { TestImportFormValues } from "./test-import.types";

export const TEST_IMPORT_DEFAULTS: Omit<
  TestImportFormValues,
  "testName" | "suggestedTime" | "questionCount" | "zipFile"
> = {
  backButton: true,
  autoAdvance: false,
  scaleAggregationMethod: "sum",
  skipCompetenciesCreation: false,
  color: "#1677FF",
  groupingEnabled: false,
};

export const AGGREGATION_METHOD_OPTIONS = [
  { label: "Sum", value: "sum" },
  { label: "Mean", value: "mean" },
];

export const MIN_GROUP_SIZE = 2;
